import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';

import { Form, Input, Icon, Button, Alert } from 'antd';

import './ForgotPasswordForm.css';
import { api } from '../../services';

import { withRouter } from 'react-router-dom';

@withRouter
@inject('authStore', 'commonStore', 'translationsStore')
@observer
export class ForgotPasswordForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      verificationCode: '',
      newPassword: '',
      stepOneRemoteError: null,
      stepTwoRemoteError: null,
      stepOneCleared: false, // TODO stepOneCleared: false
      stepTwoCleared: false
    };
  }

  onUsernameChange = e => {
    this.setState({
      username: e.target.value,
      stepOneRemoteError: null,
      stepTwoRemoteError: null
    });
  };

  onVerificationCodeChange = e => {
    this.setState({
      verificationCode: e.target.value,
      stepOneRemoteError: null,
      stepTwoRemoteError: null
    });
  };

  onNewPasswordChange = e => {
    this.setState({
      newPassword: e.target.value,
      stepOneRemoteError: null,
      stepTwoRemoteError: null
    });
  };

  afterStepOneCloseAlert = () => {
    this.setState({ stepOneRemoteError: null });
  };

  afterStepTwoCloseAlert = () => {
    this.setState({ stepTwoRemoteError: null });
  };

  handleForgotPasswordProceed = () => {
    const { username } = this.state;
    return api('forgotPassword', username)
      .then(data => {
        this.setState({
          stepOneCleared: true,
          stepTwoCleared: false
        });
        // procedura richiesta
        //console.log(`richiesta amplify _${username}_`);
        //console.log(data);
      })
      .catch(err => {
        //console.log(err);
        // const { message } = err;
        const errorMessage = err.message || err;
        this.setState({ stepOneRemoteError: errorMessage });
      });
  };

  handleForgotPasswordSubmit = () => {
    const { username, verificationCode, newPassword } = this.state;
    return api('forgotPasswordSubmit', username, verificationCode, newPassword)
      .then(data => {
        this.setState({
          stepOneCleared: true,
          stepTwoCleared: true
        });
      })
      .catch(err => {
        const errorMessage = err.message || err;
        this.setState({ stepTwoRemoteError: errorMessage });
      });
  };

  handleForgotPasswordGotoLogin = () => {
    //const { authStore } = this.props;
    //authStore.setShowForgotPasswordForm(false);
    this.props.history.push('/login');
  };

  handleForgotPasswordGotoStepOne = () => {
    this.setState({
      stepOneCleared: false,
      stepTwoCleared: false,
      verificationCode: '',
      newPassword: ''
    });
  };

  handleForgotPasswordDone = () => {
    this.setState({
      stepOneCleared: false,
      stepTwoCleared: false,
      username: '',
      verificationCode: '',
      newPassword: ''
    });
    this.props.history.push('/login');
  };

  render() {
    const { translationsStore } = this.props;
    const { getFieldDecorator } = this.props.form;
    return (
      <Fragment>
        {!this.state.stepOneCleared && (
          <Form className="ForgotPasswordForm">
            <Form.Item>
              {getFieldDecorator('username', {
                rules: [{ required: true, message: translationsStore.translate('forgotpassword.errorNoUsername') }]
              })(<Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Username" onChange={this.onUsernameChange} />)}
            </Form.Item>
            {this.state.stepOneRemoteError != null && (
              <Alert message={this.state.stepOneRemoteError} type="error" closable afterClose={this.afterStepOneCloseAlert} style={{ margin: '20px 0px' }} />
            )}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Button onClick={this.handleForgotPasswordGotoLogin}>{translationsStore.translate('forgotpassword.labelGotoLogin')}</Button>
              <Button type="primary" onClick={this.handleForgotPasswordProceed}>
                {translationsStore.translate('forgotpassword.labelProceed')}
              </Button>
            </div>
          </Form>
        )}
        {this.state.stepOneCleared &&
          !this.state.stepTwoCleared && (
            <Form className="ForgotPasswordSubmitForm">
              <Alert message={translationsStore.translate('forgotpassword.textCodeSent')} type="info" style={{ margin: '20px 0px' }} />
              <Form.Item>
                {getFieldDecorator('username', {
                  rules: [{ required: true, message: translationsStore.translate('forgotpassword.errorNoUsername') }]
                })(
                  <Input
                    prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    type="text"
                    placeholder={translationsStore.translate('forgotpassword.placeholderUsername')}
                    onChange={this.onUsernameChange}
                  />
                )}
              </Form.Item>
              <Form.Item>
                {getFieldDecorator('verificationCode', {
                  rules: [{ required: true, message: translationsStore.translate('forgotpassword.errorNoVerificationCode') }]
                })(
                  <Input
                    prefix={<Icon type="cloud" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    type="text"
                    placeholder={translationsStore.translate('forgotpassword.placeholderVerificationCode')}
                    onChange={this.onVerificationCodeChange}
                  />
                )}
              </Form.Item>
              <Form.Item>
                {getFieldDecorator('newPassword', {
                  rules: [{ required: true, message: translationsStore.translate('forgotpassword.errorNoNewPassword') }]
                })(
                  <Input
                    prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    type="password"
                    placeholder={translationsStore.translate('forgotpassword.placeholderNewPassword')}
                    onChange={this.onNewPasswordChange}
                  />
                )}
              </Form.Item>
              {this.state.stepTwoRemoteError != null && (
                <Alert message={this.state.stepTwoRemoteError} type="error" closable afterClose={this.afterStepTwoCloseAlert} style={{ margin: '20px 0px' }} />
              )}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button onClick={this.handleForgotPasswordGotoStepOne}>{translationsStore.translate('forgotpassword.labelGotoStepOne')}</Button>
                <Button type="primary" onClick={this.handleForgotPasswordSubmit}>
                  {translationsStore.translate('forgotpassword.labelConfirm')}
                </Button>
              </div>
            </Form>
          )}
        {this.state.stepOneCleared &&
          this.state.stepTwoCleared && (
            <div className="ForgotPasswordDone">
              <Alert message={translationsStore.translate('forgotpassword.textDone')} type="info" style={{ margin: '20px 0px' }} />
              <Button type="primary" className="ForgotPasswordDoneButton" onClick={this.handleForgotPasswordDone}>
                {translationsStore.translate('forgotpassword.labelDone')}
              </Button>
            </div>
          )}
      </Fragment>
    );
  }
}

//export default ForgotPasswordForm;
export default Form.create()(ForgotPasswordForm);



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/ForgotPasswordForm.js